import React from 'react';

const Delivery = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.34663 1.46595L8.14663 0.833179C7.09325 0.277726 6.56656 0 6 0C5.43344 0 4.90675 0.277726 3.85338 0.833178L3.66034 0.934966L9.01416 4.00904L11.4242 2.79822C11.0365 2.35701 10.4109 2.02713 9.34663 1.46595Z"
        fill="#4998F7"
      />
      <path
        d="M11.849 3.59586L9.45 4.80116V6.63183C9.45 6.88155 9.24853 7.084 9 7.084C8.75147 7.084 8.55 6.88155 8.55 6.63183V5.25333L6.45 6.30839V12C6.88075 11.8922 7.37085 11.6338 8.14662 11.2247L9.34663 10.5919C10.6376 9.91117 11.2831 9.57079 11.6416 8.95915C12 8.34751 12 7.58641 12 6.0642V5.99367C12 4.8526 12 4.13921 11.849 3.59586Z"
        fill="#4998F7"
      />
      <path
        d="M5.55 12V6.30839L0.150983 3.59586C0 4.13921 0 4.8526 0 5.99367V6.0642C0 7.58641 0 8.34751 0.358438 8.95915C0.716875 9.57079 1.36237 9.91117 2.65337 10.5919L3.85338 11.2247C4.62914 11.6338 5.11925 11.8922 5.55 12Z"
        fill="#4998F7"
      />
      <path
        d="M0.575815 2.79822L6 5.52339L8.04669 4.49511L2.71474 1.43359L2.65338 1.46595C1.58913 2.02713 0.963541 2.35701 0.575815 2.79822Z"
        fill="#4998F7"
      />
    </svg>
  );
};
export default Delivery;
